




































import { Component, Vue } from 'vue-property-decorator';
import { ISearchResult } from '../Scripts/ISearchService';
import { FilterHelper } from '../Scripts/FilterHelper';

@Component({
	components: {

	}
})
export default class PagePanel extends Vue {
	get results (): ISearchResult {
		return this.$store.state.result as ISearchResult;
	}

	get totalRecords (): number {
		return this.$store.state.result.count;
	}

	get pageSize (): number {
		return this.$store.state.pageSize;
	}

	set pageSize (size: number) {
		const helper = new FilterHelper(this.$router);
		helper.setPageSize(size);
	}

	get currentPage (): number {
		return this.$store.state.page;
	}

	get lastPage (): number {
		return Math.ceil(this.totalRecords / this.pageSize);
	}

	get previousDisabled (): boolean {
		return this.currentPage === 1;
	}

	get nextDisabled (): boolean {
		return this.currentPage === this.lastPage;
	}

	get pages (): number[] {
		let first = Math.max(1, this.currentPage - 2);
		const last = Math.min(first + 4, this.lastPage);
		first = Math.max(1, last - 4);
		return [...this.range(first, last)];
	}

	public* range (start: number, end: number, step = 1) : IterableIterator<number> {
		for (let n = start; n <= end; n += step) { yield n; }
	}

	public previous (): void{
		this.goto(this.currentPage - 1);
	}

	public goto (page: number): void {
		const helper = new FilterHelper(this.$router);
		helper.setPage(page);
	}

	public next (): void {
		this.goto(this.currentPage + 1);
	}
}
